"use client";

import type { LocationSearch as LocationSearchProps } from "@homeinstead/schemas";
import type { LocationSearchFormClassNames } from "~www/components/LocationSearchForm/LocationSearchForm";

import { cn } from "@homeinstead/ui";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import LocationSearchForm from "~www/components/LocationSearchForm/LocationSearchForm";

const SIDEBAR_SLOT_CLASS_NAMES: LocationSearchFormClassNames = {
  button: "xl:w-full",
  buttonWrapper: "xl:order-3 xl:mt-0",
  form: "xl:flex-col xl:items-stretch xl:gap-3",
};

export const LocationSearch = ({
  alignment,
  buttonText,
  buttonVariant,
  label,
  placeholder,
  showCurrentLocation,
  targetUrl,
  width,
}: Omit<LocationSearchProps, "_type">) => {
  const isSidebar = width === "sidebar";
  const router = useRouter();

  const handleSubmit = useCallback(
    (place: string) => {
      router.push(`${targetUrl || ""}?q=${encodeURIComponent(place)}`);
    },
    [router, targetUrl],
  );

  return (
    <div
      className={cn("location-search", {
        "sm:max-w-[560px]": width === "compact",
        "sm:max-w-[560px] xl:max-w-[300px]": isSidebar,
        "sm:ml-auto": alignment === "right",
        "sm:mx-auto": alignment === "center",
      })}
    >
      <LocationSearchForm
        buttonText={buttonText}
        buttonVariant={buttonVariant}
        label={label}
        onSubmit={handleSubmit}
        placeholder={placeholder}
        showCurrentLocation={showCurrentLocation}
        slotClassNames={isSidebar ? SIDEBAR_SLOT_CLASS_NAMES : undefined}
      />
    </div>
  );
};
